import {Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-investment-rebate-info-en-v2',
    templateUrl: './investment-rebate-info-en-v2.component.html',
    styleUrls: ['./investment-rebate-info-en-v2.component.css'],
    standalone: false
})
export class InvestmentRebateInfoEnV2Component implements OnInit, OnChanges {

  constructor() {
  }

  @Input() returnData;
  @Input() printActive: boolean;

  data: any;
  totalInvestment: number;
  savingAndUnitCertificate: number;
  others: number;

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.data = this.returnData?.headSummery?.rebateSummery?.rebateSummery;

    this.savingAndUnitCertificate = (this.data?.RB_CAT_APPR_SAVINGS_CERT ?? 0) + (this.data?.RB_CAT_UNIT_CERT ?? 0);

    this.others = (this.data?.RB_CAT_OTHERS_INVESTMENT_U_6_B ?? 0) + (this.data?.RB_CAT_OTHERS_SRO ?? 0) + (this.data?.RB_CAT_PENSION_SCHEME ?? 0);

    this.totalInvestment = (this.data?.RB_CAT_LIFE_INS_PREM ?? 0) + (this.data?.RB_CAT_DPS ?? 0)
      + this.savingAndUnitCertificate + (this.data?.RB_CAT_APPR_STOCKS_OR_SHARES ?? 0)
      + (this.data?.RB_CAT_GPF ?? 0) + (this.data?.RB_CAT_APPR_SUPER_ANNUATION_FUND ?? 0)
      + (this.data?.RB_CAT_RPF ?? 0) + (this.data?.RB_CAT_BENEVOLENT_FUND_GRP_INS_PREM ?? 0)
      + (this.data?.RB_CAT_ZAKAT_FUND ?? 0) + (this.data?.RB_CAT_OTHERS_INVESTMENT_U_6_B ?? 0)
      + (this.data?.RB_CAT_OTHERS_SRO ?? 0) + (this.data?.RB_CAT_PENSION_SCHEME ?? 0);
  }


}
